export default __webpack_public_path__ + "static/media/DentistCoin-NFT-6-1200x500.09dc75af.jpg";